import React from 'react';

import {
	Centerer,
	Icon,
	RootModalContainer,
	styled
} from 'ps-gui';

const Wrapper = styled.div`
	position: relative;
	padding: 24px;
	border-radius: 15px;
	background: #FBFBFB;
	box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
	min-width: ${props => props.minWidth};
	max-width: 90vw;

	> .icon[data-name=close] {
		position: absolute;
		right: 30px;
		top: 30px;
		* {
			fill: #4FC098;
		}
	}
`;

export const DialogHeader = styled.div`
	font-weight: 700;
	font-size: 24px;
	color: #575757;
	margin-right: 70px;
	margin-bottom: ${props => props.marginBottom || '36px'};
`;

export const DialogContent = styled.div`
	background: #FFFFFF;
	box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
	border-radius: 15px;
	padding: 12px;
	margin-bottom: 16px;
	max-height: ${props => props.maxHeight};
	overflow: ${props => props.overflow};
`;

export const DialogSubtext = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 30px;
	color: #575757;
	margin-bottom: ${props => props.marginBottom};
	max-width: ${props => props.maxWidth};
`;

export const DialogButtons = styled.div`
	&.vertical {
		width: 60%;
		margin: 40px auto;
		margin-bottom: 16px;
		.ps-button {
			display: table;
			width: 100%;
			margin-top: 24px;
		}
	}
	&:not(.vertical):not(.right) {
		.ps-button {
			margin-right: 24px;
		}
	}
	&.right {
		text-align: right;
	}
`;

export class Dialog extends React.PureComponent {
	render() {
		return (
			<RootModalContainer>
				<Centerer>
					<Wrapper minWidth={this.props.minWidth}>
						<Icon
							name="close"
							active
							onMouseDown={this.props.onCloseRequested}
						/>
						{this.props.children}
					</Wrapper>
				</Centerer>
			</RootModalContainer>
		);
	}
}
